export default {
  title: {
    en: 'Update to PayPal',
  },
}
